import { trackEvent } from 'shared/helpers/Analytics';

type SubscriptionAnalyticsProps =
  | {
      name: 'Carrier Opened Subscription Checkout in Paywall';
      carrier_guid?: string;
    }
  | {
      name: 'Carrier Clicked Continue to Upgrade in Subscription Details';
      utm_medium?: string;
      carrier_guid?: string;
      driver_guid?: string;
    }
  | { name: 'Carrier Updated Seats' }
  | { name: 'Carrier Opened Subscription Checkout' }
  | { name: 'Carrier Edited Subscription Billing Address' }
  | { name: 'Carrier Edited Subscription Payment Information' }
  | {
      name: 'Carrier Reactivated Subscription';
      utm_medium?: string;
      carrier_guid?: string;
      driver_guid?: string;
    }
  | {
      name: 'Carrier Clicked Reactivate';
      utm_medium?: string;
      carrier_guid?: string;
      driver_guid?: string;
    }
  | {
      name: 'Carrier Upgraded Plan';
      utm_medium?: string;
      utm_content?: string;
      carrier_guid?: string;
      driver_guid?: string;
    }
  | {
      name: 'Carrier Edited Subscription Billing Address';
      utm_medium?: string;
      carrier_guid?: string;
      driver_guid?: string;
    }
  | {
      name: 'Carrier closed subscription detail page';
      utm_medium?: string;
      utm_content?: string;
      carrier_guid?: string;
      driver_guid?: string;
    };

export function trackSubscriptionEvent(event: SubscriptionAnalyticsProps) {
  const { name, ...properties } = event;

  trackEvent(name, { ...properties });
}
